<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <h4 v-html="data.title"></h4>
        <div class="parent" v-if="data.parent">
          <h4>Parent category</h4>
          <h5>{{data.parent.name}}</h5>
        </div>
        <div class="formCnt">
          <div class="catImg hasImg" v-on:click="selectImg"
            v-if="media" :style="{'background-image': `url(${media.imageMd})`}">
            <div class="close" v-on:click.stop="media = null"></div>
          </div>
          <div class="catImg" v-else v-on:click="selectImg"></div>
          <form v-on:submit.prevent="handleSubmit">
            <div :class="{fieldGroup: true, hasError: fieldError}">
              <input type="text" class="field" :placeholder="data.placeholder"
                v-model="field" v-on:input="fieldChanged" ref="field">
              <div class="fieldError">Please input name to continue.</div>
              <div class="fieldHint">Input category name.</div>
            </div>
            <textarea v-if="data.description" placeholder="Description..."
              class="field" rows="2" v-model="fieldDesc"/>
          </form>
        </div>
        <div class="modalAction">
          <div class="deleteCat" v-on:click="deleteCat"
            v-if="data.model && data.model.id">
            Delete Category
          </div>
          <button class="btn btnSecondary" type="button"
            v-on:click="close(false)">Cancel</button>
          <button class="btn btnPrimary" type="submit" :class="{btnLoading: loading}"
            v-on:click="handleSubmit">
            <span v-if="data.action">{{data.action}}</span>
            <span v-else>Insert</span>
          </button>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
      <FormInputerShort ref="formInputer"/>
      <MediaSelector ref="mediaSelector"/>
    </div>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  name: 'addArticleCategory',
  components: {
    Confirmation,
    FormInputerShort,
    MediaSelector,
  },
  data() {
    return {
      show: false,
      loading: false,
      deleteConfirmation: false,
      deleteTitle: '',
      deleteDesc: '',
      fieldError: false,
      field: '',
      fieldDesc: '',
      media: null,
      data: {
        id: null,
        title: '',
        placeholder: '',
        action: '',
        description: '',
        model: '',
        required: '',
        parent: null,
      },
      saveUri: '',
      next: null,
    };
  },
  methods: {
    open(d, n) {
      this.data = d;
      this.next = n;
      this.show = true;
      this.field = (d.model && d.model.name) ? d.model.name : '';
      this.media = (d.model && d.model.media) ? d.model.media : null;
      this.saveUri = d.saveUri || 'article/parent';
      this.fieldDesc = (d.model && d.model.description) ? d.model.description : '';
      setTimeout(() => {
        this.$refs.field.focus();
      });
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    selectImg() {
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b) return;
        this.media = media;
      });
    },
    handleSubmit() {
      if (this.loading) return;
      if (!this.field || this.field === '') {
        this.fieldError = true;
        return;
      }
      const formData = {
        name: this.field,
        description: this.fieldDesc,
      };
      if (this.data && this.data.parent) formData.parentId = this.data.parent.id;
      if (this.media) formData.mediaId = this.media.id;
      if (this.data.model && this.data.model.id) formData.id = this.data.model.id;
      this.loading = true;
      this.$http.post(this.$config.uri(this.saveUri), formData).then((response) => {
        this.loading = false;
        this.close(true, {
          type: 'edit',
          id: response.data.data.id,
          name: formData.name,
          slug: response.data.data.slug,
        });
      });
    },
    fieldChanged() {
      this.fieldError = false;
    },
    deleteCat() {
      this.$refs.confirmDialog.open({
        title: `Delete ${this.data.model.name}`,
        desc: `Are you sure you want to delete this category? If you not tick delete content
          all content this category will not be deleted, but will not be accesible.`,
        checkbox: 'Also delete content in this category',
      }, (b, c) => {
        if (!b) return;
        this.deleteNow(c);
      });
    },
    deleteNow(c) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: 'To prevent from accidentally deleted category, you need to input your password.',
        placeholder: 'Password',
        type: 'password',
        action: 'Delete Category',
      }, (b) => {
        if (!b) return;
        this.loading = true;
        const cx = (c) ? 'YES' : 'NO';
        this.$http.get(this.$config.uri(`article/parent/${this.data.model.id}
          /delete?content=${cx}`)).then((response) => {
          this.loading = false;
          this.close(true, { type: 'delete' });
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px;
      border-radius: 5px;
      margin-top: -20px;
      text-align: center;
      overflow: hidden;
      max-width: none;
      width: 600px;
      .parent{
        box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        border-radius: 5px;
        padding: 10px 16px;
        margin-bottom: 24px;
        h4{
          font-size: 14px;
          text-transform: uppercase;
          margin: 0;
          font-weight: 600;
          color: #999;
        }
        h5{
          margin: 0;
          margin-top: -2px;
          text-align: left;
          font-size: 20px;
          color: #555;
        }
      }
      .formCnt{
        display: flex;
        .catImg{
          width: 160px; height: 160px;
          background-color: #eee;
          border-radius: 5px;
          margin-right: auto;
          position: relative;
          cursor: pointer;
          transition: background-color, box-shadow .3s ease;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          &:before{
            content: "";
            position: absolute;
            left: 0; top: 0; right: 0; bottom: 0;
            opacity: .3;
            background-image: url(../assets/image-black.png);
            background-size: 46px auto;
            background-position: center;
            background-repeat: no-repeat;
            transition: all .3s ease;
          }
          .close{
            background-color: red;
            width: 20px; height: 20px;
            position: absolute;
            right: -5px; top: -5px;
            border-radius: 50%;
            background-image: url(../assets/close-white.png);
            background-repeat: no-repeat;
            background-size: 8px auto;
            background-position: center;
            box-shadow: 2px 2px 4px rgba(0,0,0,.2);
            opacity: .8;
            transition: opacity .3s ease;
            &:hover{
              opacity: 1;
            }
          }
          &.hasImg{
            &:before{
              display: none;
            }
          }
          &:hover{
            background-color: #e5e5e5;
            box-shadow: 2px 2px 4px rgba(0,0,0,.2);
            &:before{
              opacity: .4;
            }
          }
        }
        form{
          width: calc(100% - 180px);
        }
      }
      textarea{
        margin-top: 20px;
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 20px;
        color: #444;
        text-align: left;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .modalAction{
        margin: 30px -80px -30px;
        padding: 12px 30px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        position: relative;
        .deleteCat{
          position: absolute;
          left: 30px; top: 22px;
          color: red; cursor: pointer;
          padding-left: 22px;
          opacity: .8;
          &:before{
            display: block;
            content: "";
            position: absolute;
            left: 0; top: 0;
            width: 16px; height: 20px;
            background-image: url(../assets/delete.png);
            background-size: 14px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            opacity: 1;
          }
        }
        .btn{
          margin-left: 10px;
        }
      }
    }
  }
</style>
